export default __webpack_public_path__ + "static/media/logo.6408e2e3.png";